// Verwaltet, welches Gericht an welchem Tag im rollenden 14-Tage-Speiseplan steht.
// Die eigentliche Speicherung läuft über echte Backend-Endpunkte (siehe menuApi.js:
// loadDailyMenu/saveDailyMenuSlot) - diese Datei kapselt nur die Speiseplan-eigene
// Logik obendrauf: das Nachladen des kompletten Plans und den 14-Tage-Zyklus.
//
// Speiseplan.jsx und AdminSpeiseplan.jsx rufen ausschließlich die drei Funktionen
// hier auf (loadDailyPlan, saveDailyAssignment, resolveCycleSlots) und müssen nicht
// wissen, dass dahinter ein Netzwerk-Request steckt.

import { addDays, isoDate } from "../data/mealPlan";
import { loadDailyMenu, saveDailyMenuSlot } from "./menuApi";

// Ein einmal befüllter 14-Tage-Plan soll sich danach von selbst wiederholen
// (Betriebskantinen-Menüs laufen typischerweise im 2-Wochen-Rhythmus um).
const CYCLE_LENGTH_DAYS = 14;
// Wie viele Zyklen wir maximal zurückschauen, bevor wir aufgeben (ca. 1 Jahr).
const MAX_CYCLE_LOOKBACK = 26;

// Lädt { [datum]: { fixedId, special1Id, special2Id } } für einen Standort vom
// Backend. Liefert dieselbe Form zurück wie vorher der lokale Zwischenstand, damit
// resolveCycleSlots unten unverändert bleiben kann.
export async function loadDailyPlan(locationId) {
  return loadDailyMenu(locationId);
}

// Speichert die Zuordnung für genau einen Tag eines Standorts im Backend und gibt
// den kompletten, aktualisierten Plan zurück (damit die aufrufende Seite ihren
// Zustand direkt mit einem einzigen Aufruf aktualisieren kann).
export async function saveDailyAssignment(locationId, date, slots) {
  await saveDailyMenuSlot(locationId, date, slots);
  return loadDailyPlan(locationId);
}

// Findet die Gerichte-Zuordnung für ein Datum. Gibt es für genau diesen Tag noch
// keine eigene Zuordnung, schauen wir jeweils 14 Tage zurück, ob es dort schon mal
// eine gab - so wiederholt sich ein einmal befüllter Plan automatisch im 2-Wochen-
// Rhythmus, bis jemand einen einzelnen Tag bewusst überschreibt.
export function resolveCycleSlots(dailyPlan, dateKey) {
  let cursor = dateKey;

  for (let cycle = 0; cycle < MAX_CYCLE_LOOKBACK; cycle += 1) {
    if (dailyPlan[cursor]) {
      return {
        slots: dailyPlan[cursor],
        // Zeigt an, ob das hier vom Zyklus übernommen wurde oder eine eigene
        // Zuordnung für genau dieses Datum ist (für die Admin-Anzeige nützlich).
        isInherited: cursor !== dateKey,
        sourceDate: cursor,
      };
    }

    cursor = isoDate(addDays(new Date(`${cursor}T12:00:00`), -CYCLE_LENGTH_DAYS));
  }

  return { slots: {}, isInherited: false, sourceDate: null };
}
